import { defineAsyncComponent } from 'vue';

export default function (iconName: string, iconStyle: string = 'line') {
  return defineAsyncComponent(() => import(`../../icons/${iconStyle}/${iconName}.svg`));
}
